<template>
  <div id="addModel">
    <form-dialog
        :model-param="modelParam"
        :model-data="modelData"
        :title="`新建模型 | ${this.modelType}`"
        @refresh="handlerRefresh"
    />
  </div>
</template>

<script>
import formDialog from "@/components/formDialog";
import {mapState} from "vuex";
import {Message} from "element-ui";

export default {
  name: "addModel",
  data(){
    return {
      modelParam:null,
      modelData:{},
    }
  },
  methods:{
    async getModelInputParam(modelType){
      if (modelType==='') return;
      if (sessionStorage.getItem(`${modelType}_modelParam`)){
        this.modelParam = [];
        const modelParam = JSON.parse(sessionStorage.getItem(`${modelType}_modelParam`));
        for (const param of modelParam) {
          this.modelParam.push(param);
        }
      }else {
        const userName = localStorage.getItem('username');
        const data = await this.$api.input(modelType,userName);
        console.log(data);
        const hlBrandData = await this.$api.hlbrand();
        this.modelParam = [];
        const modelParam = this.$adaptor('input',data,hlBrandData);
        this.modelParam =modelParam;
        if (modelParam){
          sessionStorage.setItem(`${modelType}_modelParam`,JSON.stringify(modelParam));
        }
      }
      this.initModelObject(this.modelParam);
    },
    initModelObject(modelParam){//用模型参数，初始化模型对象，用于给后台传数据
      const entries = [];
      const userName = localStorage.getItem('username')??'';
      for (const box of modelParam) {
        const children = [...box.childrenLeft,...box.childrenRight];
        for (const child of children){
          if (!child.value){
            switch (child.label) {
              case '项目号':
                child.value = userName+Date.now();
                break;
              case '立柱横梁':
                child.value = 'RAL5017';
                break;
              case '轨道系统':
                child.value = 'RAL1033';
                break;
            }
          }
          const entry = [child.name,child.value??''];
          entries.push(entry);
        }
      }
      this.modelData = Object.fromEntries(entries);
    },
    handlerRefresh(){
      sessionStorage.removeItem(`${this.modelType}_modelParam`);
      this.getModelInputParam(this.modelType);
      this.$message({showClose:true,message:'表单已重置',type:'success'});
    }
  },
  components:{
    formDialog,
  },
  computed:{
    ...mapState(['modelType'])
  },
  watch:{
    modelType:{
      immediate:true,
      handler(val){
        console.log('-----获取模型输入参数----');
        this.getModelInputParam(val);//获取模型输入参数
      }
    },
  }

}
</script>

<style scoped>
#addModel{
  position: fixed;
  margin: 0;
  top: 0;
  bottom: 0;
  left: 0;
  right:0;
  z-index: 1999;
  width: 100%;
  height: 100%;
}
</style>
